export type MetaGetter = (name: string) => string | null;

export const getMeta: MetaGetter = (name: string): string | null => {
    const node =
        typeof document !== "undefined"
            ? document.querySelector(`meta[name="${name}"]`)
            : null;
    const metaValue = node && node.getAttribute("content");
    return metaValue !== undefined ? metaValue : null;
};

export default getMeta;
